var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFront(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.7,
    height: 21.688,
    viewBox: "0 0 21.7 21.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_photos_785766",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M23.465,6.585,17.182,3.33V2.536a.435.435,0,0,0-.436-.436H2.436A.438.438,0,0,0,2,2.536V23.352a.435.435,0,0,0,.436.436h14.31a.435.435,0,0,0,.436-.436V19.67l6.472-12.5A.439.439,0,0,0,23.465,6.585ZM15.012,19.452h0a5.421,5.421,0,1,0-10.842,0h0V4.27H15.012Zm2.17-4.511V5.782l3.738,1.935Z",
    transform: "translate(-2 -2.1)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M131.07,133.34a2.17,2.17,0,1,0-2.17-2.17A2.17,2.17,0,0,0,131.07,133.34Z",
    transform: "translate(-123.479 -123.579)",
    fill: "#05cb24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront);
export default __webpack_public_path__ + "static/media/Front.79065d2d2fac596a0a2302805fcad407.svg";
export { ForwardRef as ReactComponent };